import React from 'react';
import { View, Text } from 'react-native';
import { Icon, type IconProps } from '@ant-design/react-native';
import { colorPalette } from '@shared/config/colorsConfig';
import { useTranslation } from 'react-i18next';

interface ParameterItemProps {
    titleKey: string;
    frequencyKey: string;
    icon?: IconProps['name'];
}

export default function ParameterItem({
    titleKey,
    frequencyKey,
    icon
}: ParameterItemProps) {
    const { t } = useTranslation();


    return (
        <View className="flex-row items-center justify-between py-3 px-2">
            <View className="flex-row items-center flex-1">
                {icon &&
                    <View className="mr-3">
                        <Icon name={icon} size={20} color={colorPalette.primary[600]} />
                    </View>
                }
                <View className="flex-1">
                    <Text className="text-base font-medium text-black mb-1">
                        {t(`vitalParameters.${titleKey}.title`, titleKey)}
                    </Text>
                    <Text className="text-sm text-gray-500">
                        {t(`screens.profile.pathDetails.frequency.${frequencyKey}`, frequencyKey)}
                    </Text>
                </View>
            </View>
        </View>
    );
}
